import React, { memo, useState, forwardRef, useImperativeHandle } from 'react';

import { useDisclosure } from '@chakra-ui/react';

import { handleTransfer } from 'api/washhub';
import { useMutation } from 'react-query';

import {
  TransferModalRef,
  TransferFormModalProps,
} from './TransferFormModal.props';

import TransferFormModalView from './TransferFormModal.view';

const TransferFormModalContainer = forwardRef<
  TransferModalRef,
  TransferFormModalProps
>((props, ref) => {
  const [type, setType] = useState<0 | 1>(0);

  const { mutate, isSuccess, reset, isLoading } = useMutation(handleTransfer, {
    onSuccess: () => {
      window.location.reload();
    },
  });

  const disclosure = useDisclosure();

  const onClose = () => {
    setType(0);
    disclosure.onClose();
    reset();
  };

  useImperativeHandle(
    ref,
    () => ({
      onOpen: (_type) => {
        disclosure.onOpen();
        setType(_type);
      },
    }),
    [],
  );

  return (
    <TransferFormModalView
      type={type}
      onClose={onClose}
      isOpen={disclosure.isOpen}
      onCreate={mutate}
      isSuccess={isSuccess}
      isLoading={isLoading}
      addDelayOnClose={props.addDelayOnClose}
    />
  );
});

const TransferFormModal = memo(TransferFormModalContainer);

export default TransferFormModal;
